export default {"src":"/_next/static/media/DOCU.7f4acdd3.svg","height":18,"width":18};